// extracted by mini-css-extract-plugin
export var cardHeader = "_f5-1";
export var contentCard = "_f5-0";
export var headerActions = "_f5-3";
export var reorderHandle = "_f5-5";
export var titleArea = "_f5-2";
export var titleAreaWithHandle = "_f5-4";